var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBriefcaseLine = function SvgBriefcaseLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.25 4.75V2.5A.75.75 0 0 1 7 1.75h6a.75.75 0 0 1 .75.75v2.25h3a.75.75 0 0 1 .75.75V16a.75.75 0 0 1-.75.75H3.25A.75.75 0 0 1 2.5 16V5.5a.75.75 0 0 1 .75-.75zM4 13v2.25h12V13zm0-1.5h12V6.25H4zm3.75-8.25v1.5h4.5v-1.5zm1.5 6h1.5v1.5h-1.5z"
  })));
};
export default SvgBriefcaseLine;